/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Channel } from '../entities/Channel';
import { ChannelSettingsServiceRepositoryImpl } from '../impls';
import { IChannelSettingsService, IChannelSettingsServiceRepository } from '../interfaces';
import { TChannelV2, TServicesParams } from '../types';

export class ChannelSettingsService implements IChannelSettingsService {
    private oChannelSettingsServiceRepository: IChannelSettingsServiceRepository;

    public constructor(params: TServicesParams) {
        this.oChannelSettingsServiceRepository = new ChannelSettingsServiceRepositoryImpl(params);
    }

    public async setChannelSettings(
        channel: Channel | TChannelV2,
        isFavorite: boolean,
    ): Promise<boolean> {
        return this.oChannelSettingsServiceRepository.setChannelSettings(channel, isFavorite);
    }
}
